import services from '../../services'

const state = {
}

const actions = {
  async personList ({commit}, query) {
    let res = await services.ioam_personList(query)
    return res.data
  },
  async departmentList ({commit}) {
    let res = await services.ioam_departmentList()
    return res.data
  }
}

const mutations = {
}
export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/ioam.js